<template>
  <div class="compose-con">
    <!--email reply bar-->
    <ul class="email-reply-bar">
      <li><a href="javascript:void(0)" @click="deleteMail" class="icon-delete-email"></a></li>
      <li v-if="'inbox' === type"><a href="javascript:void(0)" @click="toggleMoveClick" class="icon-move-email"></a></li>
      <li v-if="type != 'draft'"><a href="javascript:void(0)" @click="openReply" class="btn-primary">Reply</a></li>
      <li v-else><a href="javascript:void(0)" @click="editDraft" class="btn-primary">Edit</a></li>
      <!--<li><a href="javascript:void(0)" @click="navigateToComposeMail" class="icon-compose-email"></a></li>-->
      <li v-if="type != 'draft'"><a href="javascript:void(0)" @click="toggleMoreBtn" class="btn-primary">More</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
  },
  methods: {
    toggleMoveClick() {
      this.$emit("toggleMoveClick");
    },
    navigateToComposeMail() {
      this.$router.push("/compose-email");
    },
    deleteMail() {
      this.$emit("deleteMailClicked");
    },
    toggleMoreBtn(event) {
      this.$emit("toggleMoreBtn", event);
    },
    editDraft() {
      this.$emit("editDraft");
    },
    openReply() {
      this.$emit("replyMail", 'reply');
    }
  }
};
</script>

<style scoped>
.compose-con{
  position: fixed;
  bottom:0;
  right:0;
  background:#f8f8f8;
  padding:10px;
  border-top:1px solid #c2c2c2;
  width:calc(100% - 20px);
}
.compose, .toTrash {
  float: right;
  background:#d26d13;
  padding:5px 8px;
  color:#fff;
  border:1px solid #ae5003;
  cursor:pointer;
  border-radius:5px;
  outline:none!important;
}
.move {
  float: left;
  background:#d26d13;
  padding:5px 8px;
  color:#fff;
  border:1px solid #ae5003;
  cursor:pointer;
  border-radius:5px;
  outline:none!important;
  margin-left:20px;
}
.compose:hover, .toTrash:hover, .move:hover {
   background-color: #e56700;
}
/*--email reply bar--*/
.email-reply-bar{
  display:flex;
  justify-content: space-between;
  flex-grow: 1;
}
.email-reply-bar li{
    align-self: center;
    padding:0 10px;
}
.email-reply-bar li a{
  width:28px;
  height: 28px;
  display:block;
}
.email-reply-bar li a.icon-delete-email{
        background:url('../../../assets/img/icon-email-trash-medium.png') no-repeat;
}
.email-reply-bar li a.icon-move-email{
      background:url('../../../assets/img/icon-move-email.png') no-repeat;


}
.email-reply-bar li a.icon-compose-email{
        background:url('../../../assets/img/icon-compose-email.png') no-repeat;


}
.email-reply-bar li a.btn-primary{
  width:auto;
     color: #fff;
    border: none;
    cursor: pointer;
    font-weight: bold;
    font-size:14px;
    line-height: 24px;
      border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
        background: #d26d13;
        padding:0 10px;


}
</style>
